import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { getReportingRole } from 'src/components/AuthProvider/authUtils';
import { removeEmptyProperties } from 'src/utilities/removeEmptyProperties';

interface TealiumData {
  brand?: string;
  clientName?: string;
  corpclientID: string;
  corpSalesforceFirmID?: string;
  corpType?: string;
  corpAdminEmailAddress: string;
  grubhubInternalAdmin: string;
  role: string;
  userid: string;
}

export const useTealiumData = (): Partial<TealiumData> => {
  const {
    user,
    enterpriseData: {
      isInternalAdminUser,
      isFinancialAdminUser,
      isParentAdminUser,
    },
    corpData,
    corpId,
  } = useAuth();

  const userRole = getReportingRole(
    isInternalAdminUser,
    isFinancialAdminUser,
    isParentAdminUser,
    corpData?.signUpType
  );

  const tealiumData: TealiumData = {
    brand: (user?.brand || '').toLowerCase(),
    clientName: corpData?.name,
    corpclientID: corpId,
    corpSalesforceFirmID: corpData?.clientId,
    corpType: corpData?.signUpType,
    corpAdminEmailAddress: user?.email,
    grubhubInternalAdmin: isInternalAdminUser ? 'true' : 'false',
    role: userRole,
    userid: user?.ud_id,
  };

  // Avoid sending properties with undefined, null, empty string values to third-party vendors.
  // This prevents third parties from interpreting blank fields as updates to clear existing values.
  return removeEmptyProperties(tealiumData);
};
